import React from 'react';

const modernHeaderStyles = `
  .report-header-modern-card {
    background: linear-gradient(135deg, #f8fafc 60%, #e0e7ff 100%);
    border-radius: 18px;
    box-shadow: 0 4px 24px 0 rgba(80, 80, 120, 0.10);
    padding: 2rem 1.5rem 1.5rem 1.5rem;
    margin: 0 auto 2rem auto;
    max-width: 600px;
    position: relative;
    z-index: 1;
  }
  .report-header-modern-btn-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 0.5rem;
  }
  .report-header-modern-btn {
    background: #fff;
    color: #3b3b6d;
    border: 2px solid #6366f1;
    border-radius: 8px;
    font-weight: 600;
    font-size: 1rem;
    padding: 0.7rem 1.5rem;
    transition: all 0.18s cubic-bezier(.4,0,.2,1);
    box-shadow: 0 2px 8px 0 rgba(99,102,241,0.08);
    outline: none;
    cursor: pointer;
  }
  .report-header-modern-btn.selected {
    background: linear-gradient(90deg, #6366f1 60%, #818cf8 100%);
    color: #fff;
    border: 2px solid #6366f1;
    box-shadow: 0 4px 16px 0 rgba(99,102,241,0.13);
    transform: scale(1.04);
  }
  @media (max-width: 600px) {
    .report-header-modern-card {
      padding: 1.2rem 0.5rem 1rem 0.5rem;
    }
    .report-header-modern-btn {
      font-size: 0.98rem;
      padding: 0.6rem 1rem;
    }
  }
`;

export default function ReportHeader(props) {
  const { handleToggleReport, reportName } = props;

  return (
    <div className="report-header-modern-card">
      <style>{modernHeaderStyles}</style>
      <div style={{textAlign: 'center', fontWeight: 700, fontSize: '1.25rem', marginBottom: '0.7rem', letterSpacing: '0.5px', color: '#3b3b6d'}}>Select Report Type</div>
      <form id="contact" autoComplete="off" onSubmit={e => e.preventDefault()}>
        <div className="report-header-modern-btn-group">
          <button
            type="button"
            className={`report-header-modern-btn${reportName === "Issue" ? " selected" : ""}`}
            onClick={event => handleToggleReport(event, "Issue")}
          >
            Issue Report
          </button>
          <button
            type="button"
            className={`report-header-modern-btn${reportName === "Books" ? " selected" : ""}`}
            onClick={event => handleToggleReport(event, "Books")}
          >
            Books Report
          </button>
          <button
            type="button"
            className={`report-header-modern-btn${reportName === "Custom" ? " selected" : ""}`}
            onClick={event => handleToggleReport(event, "Custom")}
          >
            Custom Report
          </button>
        </div>
      </form>
    </div>
  );
}
